export default __webpack_public_path__ + "static/media/842.11dabf14.png";